import ModularHeaderItems from './ModularHeaderItems';

export default ModularHeaderItems;